import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import BrandMark from "./BrandMark";

const navItems = [
  { label: "Home", href: "/#home", id: "home" },
  { label: "Services", href: "/#services", id: "services" },
  { label: "How It Works", href: "/#how-it-works", id: "how-it-works" },
  { label: "Fleet Partners", href: "/#fleet-partners", id: "fleet-partners" },
  { label: "About Us", to: "/about-us" },
  { label: "Contact", to: "/contact-us" }
];

export default function PremiumHeader({ isLoggedIn = false }) {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    if (location.pathname !== "/") return undefined;

    const updateActiveSection = () => {
      const offset = window.scrollY + 150;
      const visibleSection = ["fleet-partners", "how-it-works", "services", "home"]
        .find((id) => {
          const element = document.getElementById(id);
          return element && element.offsetTop <= offset;
        });
      setActiveSection(visibleSection || "home");
    };

    updateActiveSection();
    window.addEventListener("scroll", updateActiveSection, { passive: true });
    return () => window.removeEventListener("scroll", updateActiveSection);
  }, [location.pathname]);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const handleEscape = (event) => {
      if (event.key === "Escape") setMenuOpen(false);
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="pl-header">
      <div className="pl-container pl-header__inner">
        <BrandMark onClick={closeMenu} />

        <nav className={`pl-nav${menuOpen ? " pl-nav--open" : ""}`} aria-label="Primary navigation">
          <div className="pl-nav__links">
            {navItems.map((item) => item.to ? (
              <Link key={item.label} className={location.pathname === item.to ? "is-active" : ""} to={item.to} onClick={closeMenu}>
                {item.label}
              </Link>
            ) : (
              <a
                key={item.id}
                className={location.pathname === "/" && activeSection === item.id ? "is-active" : ""}
                href={item.href}
                onClick={closeMenu}
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="pl-nav__actions">
            <Link className="pl-login-link" to={isLoggedIn ? "/bookings" : "/login"} onClick={closeMenu}>
              <LoginRoundedIcon aria-hidden="true" />
              {isLoggedIn ? "My Account" : "Login"}
            </Link>
            <Link className="pl-button pl-button--primary pl-button--header" to="/addbookings" onClick={closeMenu}>
              <LocalShippingRoundedIcon aria-hidden="true" />
              Book a Shipment
            </Link>
          </div>
        </nav>

        <button
          className="pl-menu-toggle"
          type="button"
          aria-label={menuOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? <CloseRoundedIcon /> : <MenuRoundedIcon />}
        </button>
      </div>
    </header>
  );
}
